import { IStorageService } from "./storage-service";

export class StorageProvider<T extends string> implements angular.IServiceProvider {
    private STORAGE_OBJ: IStorageService<T>;

    public build(name: string, ctor: { new(name: string): IStorageService<T> }) {
        this.STORAGE_OBJ = new ctor(name);
    }

    public $get = function () {
        return this.STORAGE_OBJ;
    };
}